import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const IesPersonalInformationLabels: IntakeLabelCollection = {
  firstName: {
    label: 'First name',
  },
  preferredName: {
    label: 'Preferred name, if different',
  },
  middleName: {
    label: 'Middle name',
  },
  lastName: {
    label: 'Last name',
  },
  sin: {
    label: 'Social Insurance Number',
  },
  gender: {
    label: 'Gender',
  },
  email: {
    label: 'Email address',
  },
  phoneNumber: {
    label: 'Phone number',
  },
  birthdate: {
    label: 'Birthdate',
  },
  immigrationStatus: {
    label: 'Citizenship / Immigration status',
  },
  immigrationStatusSponsored: {
    label: 'Are you sponsored?',
    spousePartnerLabel: 'Is your <<spouseLabel>> sponsored?',
    thirdPersonLabel: 'Is <<personName>> sponsored',
  },
  immigrationStatusOther: {
    label: 'Please explain your immigration status',
    thirdPersonLabel: `Please explain <<personName>>'s immigration status`,
  },
  sponsorshipEndDate: {
    label: 'Sponsorship End Date',
  },
  hasIndianRegistration: {
    label: 'Do you have an Indian Registration Number?',
    spousePartnerLabel: 'Does your <<spouseLabel>> have an Indian Registration Number?',
    thirdPersonLabel: 'Does <<personName>> have an Indian Registration Number?',
  },
  indianRegistrationNumber: {
    label: 'Indian Registration Number',
  },
  livesOnReserve: {
    label: 'Are you living on the reserve?',
    spousePartnerLabel: 'Is your <<spouseLabel>> living on a reserve?',
    thirdPersonLabel: 'Is <<personName>> living on a reserve?',
  },
  receivesFundsFromBand: {
    label: 'Do you receive funds from your Band?',
    spousePartnerLabel: 'Does your <<spouseLabel>> receive funds from their Band?',
    thirdPersonLabel: 'Does <<personName>> receive funds from <<genderPersonHisHer>> Band?',
  },
  livesWithApplicant: {
    label: 'Does your spouse/partner live with you?',
    spousePartnerLabel: 'Does your <<spouseLabel>> live with you?',
    thirdPersonLabel: 'Does <<spouseName>> live with <<applicantName>>?',
  },
  livingSituation: {
    label: 'Living situation',
  },
  monthlyRentAndUtilities: {
    label: 'Monthly rent including utilities',
  },
  monthlyMortgageAndUtilities: {
    label: 'Monthly mortgage including utilities',
  },
  monthlyRoomAndBoardAndUtilities: {
    label: 'Monthly room and board including utilities',
  },
  paysForPowerElectricity: {
    label: 'Do you pay your own power/electricity?',
    thirdPersonLabel: 'Does <<applicantName>> pay <<genderApplicantHisHer>> own power/electricity?',
  },
  powerElectricityCosts: {
    label: 'Power/electricity costs',
  },
  livingWithRelatives: {
    label: 'Indicate the relationship to the adult relative',
  },
  livingSituationsOther: {
    label: 'Please describe your living situation',
    thirdPersonLabel: `Please describe <<applicantName>>'s living situation`,
  },
  livesWithGrandparent: {
    label: 'Grandparent',
  },
  livesWithParentStepParent: {
    label: 'Parent/Step parent',
  },
  livesWithAdultChildOrAdultGrandchild: {
    label: 'Adult child/Adult grandchild',
  },
  mailingAddressDifferent: {
    label: 'Is your mailing address different than your home address?',
    thirdPersonLabel: `Is <<applicantName>>'s mailing address different than <<genderApplicantHisHer>> home address?`,
  },
  hasMailingAddress: {
    label: 'Do you have a mailing address where you can be contacted?',
    thirdPersonLabel: 'Does <<applicantName>> have a mailing address where <<genderApplicantHeShe>> can be contacted?',
  },
  streetAddress: { label: 'Street address' },
  suiteNumber: { label: 'Suite or unit #' },
  city: { label: 'City/town' },
  province: { label: 'Province/territory' },
  postalCode: { label: 'Postal code' },
};
